import { Download, FileSpreadsheet, FileText, Image } from "lucide-react"
import type { FC } from "react"
import { FleetHealthByCouncilWidget } from "@/components/FleetHealthByCouncilWidget"
import { LeakAlertsWidget } from "@/components/LeakAlertsWidget"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import type { AdminCouncilInfo, LeakTrendsDTO } from "@/gen/api"

interface AdvancedAnalyticsSectionProps {
  councilInfos?: AdminCouncilInfo[]
  leakTrends?: LeakTrendsDTO
  leakTrendsLoading?: boolean
  onExport: (type: string, format: string) => void
}

export const AdvancedAnalyticsSection: FC<AdvancedAnalyticsSectionProps> = ({
  councilInfos,
  leakTrends,
  leakTrendsLoading = false,
  onExport,
}) => {
  return (
    <div className="space-y-4" data-analytics-section>
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold mb-2">Advanced Analytics</h2>
          <p className="text-sm text-muted-foreground">
            Leak trends and device performance insights
          </p>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="gap-2">
              <Download className="size-4" />
              Export Analytics
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => onExport("analytics", "csv")}>
              <FileSpreadsheet className="size-4 mr-2" />
              Export as CSV
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onExport("analytics", "pdf")}>
              <FileText className="size-4 mr-2" />
              Export as PDF
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onExport("analytics", "png")}>
              <Image className="size-4 mr-2" />
              Export as PNG
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="space-y-6">
        <LeakAlertsWidget leakTrends={leakTrends} isLoading={leakTrendsLoading} variant="master" />
        {councilInfos ? <FleetHealthByCouncilWidget councilInfos={councilInfos} /> : null}
      </div>
    </div>
  )
}
